import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../../hooks/UserContext"; // важно: путь из components/protectedRoute

export default function ProtectedRoute({ need = [], children }) {
  const { user, permissions, authLoading } = useContext(UserContext);

  if (authLoading) return null; // можно лоадер
  if (!user) return <Navigate to="/login" replace />;

  const ok = need.every((p) => (permissions || []).includes(p));
  if (!ok) return <Navigate to="/no-access" replace />;

  return children;
}
